// 卡状态
export default {
  1: '启用',
  2: '停用',
  3: '未启用',
  4: '挂失',
  5: '过期'
};



// WEBPACK FOOTER //
// ./src/constants/card/status.js